<template>
  <h1>Approved</h1>
</template>
